import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/Card';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';
interface PerformanceChartProps {
  title: string;
  data: any[];
  type?: 'line' | 'bar';
  dataKey: string;
  color?: string;
}
export function PerformanceChart({
  title,
  data,
  type = 'line',
  dataKey,
  color = '#8884d8'
}: PerformanceChartProps) {
  return <Card className="col-span-1" data-id="element-258">
      <CardHeader data-id="element-259">
        <CardTitle data-id="element-260">{title}</CardTitle>
      </CardHeader>
      <CardContent className="pl-2" data-id="element-261">
        <div className="h-[300px] w-full" data-id="element-262">
          <ResponsiveContainer width="100%" height="100%" data-id="element-263">
            {type === 'line' ? <LineChart data={data} data-id="element-264">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" data-id="element-265" />
                <XAxis dataKey="name" stroke="#888888" fontSize={12} tickLine={false} axisLine={false} data-id="element-266" />
                <YAxis stroke="#888888" fontSize={12} tickLine={false} axisLine={false} tickFormatter={value => `${value}`} data-id="element-267" />
                <Tooltip contentStyle={{
              borderRadius: '8px',
              border: 'none',
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
            }} data-id="element-268" />
                <Line type="monotone" dataKey={dataKey} stroke={color} strokeWidth={2} dot={false} activeDot={{
              r: 6
            }} data-id="element-269" />
              </LineChart> : <BarChart data={data} data-id="element-270">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" data-id="element-271" />
                <XAxis dataKey="name" stroke="#888888" fontSize={12} tickLine={false} axisLine={false} data-id="element-272" />
                <YAxis stroke="#888888" fontSize={12} tickLine={false} axisLine={false} tickFormatter={value => `${value}`} data-id="element-273" />
                <Tooltip cursor={{
              fill: 'transparent'
            }} contentStyle={{
              borderRadius: '8px',
              border: 'none',
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
            }} data-id="element-274" />
                <Bar dataKey={dataKey} fill={color} radius={[4, 4, 0, 0]} data-id="element-275" />
              </BarChart>}
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>;
}